import React from 'react';
import config from '../config/config';
import { getCurrentLocation } from '../services/currentLocationService';

const ICON_URLS = {
  nearMe: `${config.icons.baseUrl}${config.icons.nearMe}`,
  nearMeFill: `${config.icons.baseUrl}${config.icons.nearMeFill}`,
  plus: `${config.icons.baseUrl}${config.icons.plus}`,
  minus: `${config.icons.baseUrl}${config.icons.minus}`,
};

const DESCRIPTION_ZOOM_IN = '拡大';
const DESCRIPTION_ZOOM_OUT = '縮小';
const DESCRIPTION_CURRENT_LOCATION = '現在地へ移動';
const BUTTON_STATES_LOCATED = 'located';

/**
 * 画面右下のボタン群コンポーネント
 */
const KntrMapControls = ({
  map,
  onZoomInClick,
  onZoomOutClick,
  currentLocationButtonState, // 現在地ボタンの状態
  setCurrentLocationButtonState, // 現在地ボタンの状態更新関数
  setHasMapMoved, // 地図が移動したかどうかの状態更新関数
}) => {

  // 現在地
  const handleCurrentLocationClick = () => {
    getCurrentLocation(map, setCurrentLocationButtonState, setHasMapMoved);
  };

  return (
    <div className="kntr-map-controls">

      {/* ズームイン・アウトボタン */}
      <div className="zoom-controls">
        <button
          id="zoom-in-btn"
          className="kntr-map-control-btn"
          title={DESCRIPTION_ZOOM_IN}
          aria-label={DESCRIPTION_ZOOM_IN}
          onClick={onZoomInClick}
        >
          <i
            className="svg-icon-blue"
            style={{ backgroundImage: `url('${ICON_URLS.plus}')` }}
          ></i>
        </button>
        <button
          id="zoom-out-btn"
          className="kntr-map-control-btn"
          title={DESCRIPTION_ZOOM_OUT}
          aria-label={DESCRIPTION_ZOOM_OUT}
          onClick={onZoomOutClick}
        >
          <i
            className="svg-icon-blue"
            style={{ backgroundImage: `url('${ICON_URLS.minus}')` }}
          ></i>
        </button>
      </div>

      {/* 現在地ボタン */}
      <button
        id="current-location-btn"
        className="kntr-map-control-btn"
        title={DESCRIPTION_CURRENT_LOCATION}
        aria-label={DESCRIPTION_CURRENT_LOCATION}
        data-state={currentLocationButtonState}
        onClick={handleCurrentLocationClick}
      >
        <i
          className="svg-icon-blue"
          style={{
            backgroundImage:
              currentLocationButtonState === BUTTON_STATES_LOCATED
                ? `url('${ICON_URLS.nearMeFill}')`
                : `url('${ICON_URLS.nearMe}')`,
          }}
        ></i>
      </button>

    </div>
  );
};

export default KntrMapControls;